export enum ReOrder {
    EVALUATEREORDER = 'evaluateReorder',
    REORDER = 'reOrder',
    REORDER_LINEITEM_ORDERTYPE = 'REORDER',
    GENERATEPDPLINK = 'generatePdpLink' 
}